// extracted by mini-css-extract-plugin
module.exports = {"logoCircle":"LogoBubble-module__logoCircle____MG76"};